import { render, staticRenderFns } from "./AlgoliaSearch.vue?vue&type=template&id=cbcab226"
import script from "./AlgoliaSearch.vue?vue&type=script&lang=js"
export * from "./AlgoliaSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports